// Service
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"
// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
// Constants
import { STATUS_CODES } from "@/app/constants/constants"


export default {
	name: 'BreederLitterManagementComponent',
	components: {},
	directive: {},
	filters: {},
	mixins: [
		toastMessageMixins,
		tableMixins
	],
	props: {},
	data() {
		return {
			isAPILoading: false,
			// table
			theads: [
				{
					name: "Mating Name",
					searchLabel: "f_matingName",
					sortLabel: "matingName",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 185px;"
				},
				{
					name: "Litter Count",
					searchLabel: "f_totalLitters",
					sortLabel: "totalLitters",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 185px;"
				},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 170px" },
			],
			// pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
			limit: 10,
			// sorting
			sortBy: '',
			desc: true,
			columnsFilter: {},
			matingData: {},
			tableContent: {
				tableData: [],
				paginationData: {},
			},
			breederSysId: null,
			filterValues:{},
		}
	},
	computed: {},
	watch: {},
	created() {
		this.breederSysId = this.$route.params.id
		this.loadSavedFilters()
		this.getTableContent()
	},
	activated() {
		this.loadSavedFilters()
        this.getTableContent();
	},
	methods: {
        onColumnDataFilter(filterBy, event) {
			if (filterBy) {
				this.page = 1;
                this.columnsFilter[filterBy] = event.target.value;
                this.filterValues[filterBy] = event.target.value;
				this.delayTyping(() => {
					this.getTableContent(false, this.page, this.limit, this.sortBy, this.desc);
				});
			}
		},
        clearFilters() {
            const filters = this.$store.state.breederLitterManagementFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0; 
            if (hasFilters) {
                this.$store.dispatch('resetBreederMatingListFilters');
            }
        },
        saveAllFilters() {
            const filters = {};
                // Collect all the column filter values
                this.theads.forEach(th => {
                    const searchInput = this.columnsFilter[`${th.searchLabel}`];
					if (searchInput) {
						filters[th.searchLabel] = searchInput;
					}
                });

                // Add pagination details to filters
                filters.page = this.page; // current page
                filters.limit = this.limit; // items per page
				filters.sortBy = this.sortBy
                filters.isDesc = this.desc
                // Dispatch all filters, including pagination, to Vuex store
                Object.keys(filters).forEach(label => {
                    this.$store.dispatch('applyBreederLitterManagementFilters', { label, value: filters[label] });
                });
          },  
          loadSavedFilters() {
            const filters = this.$store.state.breederLitterManagementFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0;
            if (hasFilters) {
				this.page = this.$store.getters.getBreederMatingListFilters('page') || 1;
				this.limit = this.$store.getters.getBreederMatingListFilters('limit') || 10; 
				this.sortBy = this.$store.getters.getBreederMatingListFilters('sortBy') || '';
				this.desc = this.$store.getters.getBreederMatingListFilters('isDesc'); 

                // You can access the saved filter values from the store like this:
                this.theads.forEach(th => {
					if(this.sortBy === th.sortLabel) {
						th.isDesc =  this.desc
					}
                    const savedFilter = this.$store.getters.getBreederLitterManagementFilters(th.searchLabel);
                    if (savedFilter) {
                        this.columnsFilter[th.searchLabel] = savedFilter;
                        this.filterValues[th.searchLabel] = savedFilter
                    }

                }); 
                this.clearFilters()
            }
        },  
		getTableContent(
			fromFilter = false,
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
		) {
			page = fromFilter ? 1 : this.page
			this.getLitterManagementList({ page, limit, sortBy, desc })
		},

		getLitterManagementList(queryParams) {
			this.isAPILoading = true
			queryParams["f_breederSysId"] = this.$route.params.id

			if (this.columnsFilter) {
				if (this.columnsFilter.f_matingName) {
					queryParams["f_matingName"] = this.columnsFilter.f_matingName
				}
				if (this.columnsFilter.f_totalLitters) {
					queryParams["f_totalLitters"] = this.columnsFilter.f_totalLitters
				}
			}


			breedingManagementService
				.getLitterManagementList(queryParams)
				.then((response) => {
					if (response.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: response.data.data,
							paginationData: response.data.pagination
						}
					}
					this.isAPILoading = false
				})
				.catch((error) => {
					this.showGenericErrorToast()
				})
				.finally(() => {
					this.isAPILoading = false
				})
		},

		gotoLitterManagementDetails(matingId) {
			this.saveAllFilters();
			const savedTabId = localStorage.getItem('selectedTab');
            if (!savedTabId) {
               localStorage.setItem('selectedTab', 'litterList');
            } 
			this.$router.push(`/breeder-management/litter-puppy-list/${this.breederSysId}/${matingId}`)
		},
	},
	// third party libraries
}